import { render, staticRenderFns } from "./Sorteos.vue?vue&type=template&id=4c10d5a9&scoped=true&"
import script from "./Sorteos.vue?vue&type=script&lang=js&"
export * from "./Sorteos.vue?vue&type=script&lang=js&"
import style0 from "./Sorteos.vue?vue&type=style&index=0&id=4c10d5a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10d5a9",
  null
  
)

export default component.exports